import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getUIPhase } from '../../utils/AuctionPhase';
import './_styles_/AuctionPhase.css';

AuctionHeaderPhase.propTypes = {
    phase: PropTypes.string.isRequired,
};

function AuctionHeaderPhase(props) {
    const {
        phase,
    } = props;
    const { t } = useTranslation();
    const uiPhase = getUIPhase(phase);
    return (
        <div className="auction-header--phase">
            <div className={`auction-header--phase--content ${uiPhase.id}`}>
                <FontAwesomeIcon icon={uiPhase.icon} />
                &nbsp;
                {uiPhase.translate(t)}
            </div>
        </div>
    );
}

export default AuctionHeaderPhase;
